import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning',
  isLoading = false 
}) => {
  if (!isOpen) return null;

  const typeConfig = {
    warning: {
      icon: 'AlertTriangle',
      iconColor: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      buttonVariant: 'warning'
    },
    danger: {
      icon: 'AlertCircle',
      iconColor: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      buttonVariant: 'destructive'
    },
    info: {
      icon: 'Info',
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      buttonVariant: 'default'
    }
  };

  const config = typeConfig?.[type] || typeConfig?.warning;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="relative bg-card rounded-lg shadow-elevation-lg w-full max-w-md mx-4">
        <div className="p-6">
          <div className={`w-12 h-12 ${config?.bgColor} ${config?.borderColor} border rounded-lg flex items-center justify-center mx-auto mb-4`}>
            <Icon name={config?.icon} size={24} className={config?.iconColor} />
          </div>
          
          <div className="text-center mb-6">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              {title}
            </h3>
            <p className="text-muted-foreground">
              {message}
            </p>
          </div>

          <div className="flex items-center justify-center space-x-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText}
            </Button>
            <Button
              variant={config?.buttonVariant}
              onClick={onConfirm}
              loading={isLoading}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;